export default __webpack_public_path__ + "1bb7eb816750af22ab00a08f06ce3263.svg";